import React from "react"
import { IRISH_COUNTIES } from "@dc-ireland/shared"

const inputClassName =
  "w-full rounded-xl border border-[#e5e5e5] bg-white px-3.5 py-3 font-dm-sans text-base tracking-wide text-[#0d0d0d] outline-none transition focus:border-dc-primary-900/40 focus:ring-2 focus:ring-dc-primary-900/10"

const labelClassName =
  "font-dm-sans text-xs font-semibold uppercase tracking-wider text-[#787878]"

type Props = {
  id: string
  value: string
  onChange: (county: string) => void
}

const LandingCountyField: React.FC<Props> = ({ id, value, onChange }) => {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className={labelClassName}>
        County (optional)
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={inputClassName}
      >
        <option value="">Select a county</option>
        {IRISH_COUNTIES.map((county) => (
          <option key={county} value={county}>
            {county}
          </option>
        ))}
      </select>
    </div>
  )
}

export default LandingCountyField
